<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import ConfirmDialog from '../../components/TwConfirmDialog';
import validatorMixin from '../../mixins/validatorMixin';
import TransportationDeparturePriceCabin from '../../components/transportation/TransportationDeparturePriceCabin';
import TransportationDeparturePriceExtra from '../../components/transportation/TransportationDeparturePriceExtra';
import TransportationDepartureBlockDays from '../../components/transportation/TransportationDepartureBlockDays';
import transportTypes from '../../variables/transportTypes';

export default {
  name: 'TransportationPrices',
  components: {
    ConfirmDialog,
    TransportationDeparturePriceCabin,
    TransportationDeparturePriceExtra,
    TransportationDepartureBlockDays,
  },
  mixins: [
    validatorMixin,
  ],
  data() {
    return {
      isSeasonEditable: false,
      seasonEdit: {
        startDate: null,
        endDate: null,
        ferryRouteId: null,
        name: '',
        startedAt: null,
        endedAt: null,
        active: true,
      },
      isSeasonDepartureEditable: false,
      selectedRouteType: 'train',
      currentDeparture: {
        ferryId: null,
        ferrySeasonId: null,
        name: '',
        outBoundTimeFrom: '',
        outBoundTimeTo: '',
        inBoundTimeFrom: '',
        inBoundTimeTo: '',
      },
      departurePriceCabinEditable: false,
      departurePriceExtraEditable: false,
      departureDaysEditable: false,
      departureBlockDaysEditable: false,
      headers: [
        { text: 'Name', sortable: false, class: 'px-4', value: 'name' },
        { text: 'Departure', sortable: false, class: 'px-2', value: 'timeOutbound' },
        { text: 'Arrival', sortable: false, class: 'px-2', value: 'timeInbound' },
        { text: 'Days(inbound)', sortable: false, class: 'px-1', value: 'days' },
        { text: 'Days(outbound)', sortable: false, class: 'px-1', value: 'days' },
        { text: 'Cabin prices', sortable: false, class: 'px-2', value: 'cabins' },
        { text: 'Extra prices', sortable: false, class: 'px-2', value: 'extras' },
        { text: '', sortable: false, class: 'px-1', value: '' },
      ],
      headersTrain: [
        { text: 'Name', sortable: false, class: 'px-4', value: 'name' },
        { text: 'Dept.(outbound)', sortable: false, class: 'px-2', value: 'timeOutbound' },
        { text: 'Dept.(inbound)', sortable: false, class: 'px-2', value: 'timeOutbound' },
        { text: 'Arr.(outbound)', sortable: false, class: 'px-2', value: 'timeOutbound' },
        { text: 'Arr.(inbound)', sortable: false, class: 'px-2', value: 'timeInbound' },
        { text: 'Days(outbound)', sortable: false, class: 'px-1', value: 'days' },
        { text: 'Days(inbound)', sortable: false, class: 'px-1', value: 'days' },
        { text: 'Cabin prices', sortable: false, class: 'px-2', value: 'cabins' },
        { text: 'Extra prices', sortable: false, class: 'px-2', value: 'extras' },
        { text: 'Block days(outbound)', sortable: false, class: 'px-2', value: 'extras' },
        { text: 'Block days(inbound)', sortable: false, class: 'px-2', value: 'extras' },
        { text: '', sortable: false, class: 'px-1', value: '' },
      ],
      pickerDays: [],
      selectedDeparture: null,
      ferry: transportTypes.FERRY,
      train: transportTypes.TRAIN,
      flight: transportTypes.FLIGHT,
    };
  },
  computed: {
    ...mapState({
      routes: state => state.transportation.routes.items,
      routesLoading: state => state.transportation.routes.itemsLoading,
      supplier: state => state.transportation.suppliers.supplier,
      suppliers: state => state.transportation.suppliers.items,
      suppliersLoading: state => state.transportation.suppliers.itemsLoading,
      suppliersError: state => state.transportation.suppliers.itemsError,
      season: state => state.transportation.prices.season,
      route: state => state.transportation.prices.route,
      ferrySeasonPrices: state => state.transportation.ferry.season.prices,
      ferrySeasonPricesLoading: state => state.transportation.ferry.season.prices.loading,
      ferrySeasonPricesError: state => state.transportation.ferry.season.prices.error,
      departures: state => state.transportation.departures.items,
      departuresLoading: state => state.transportation.departures.loading,
      departuresError: state => state.transportation.departures.error,
      departureDays: state => state.transportation.departures.days.items,
      departureDaysFiltered: state => state.transportation.departures.days.filteredItems,
      departureDaysLoading: state => state.transportation.departures.days.loading,
    }),
    ...mapGetters({
      getRoutes: 'transportation/getRoutes',
      getSeasons: 'transportation/getSeasons',
      getSeasonDepartures: 'transportation/getSeasonDepartures',
      getSeasonPriceCategories: 'transportation/getSeasonPriceCategories',
    }),
    isFerrySeasonValid() {
      if (!this.seasonEdit.startDate || this.seasonEdit.startDate.length !== 8) {
        return false;
      }
      if (!this.seasonEdit.endDate || this.seasonEdit.endDate.length !== 8) {
        return false;
      }
      return this.$moment(this.seasonEdit.startDate, 'DD/MM/YY').isValid()
        && this.$moment(this.seasonEdit.endDate, 'DD/MM/YY').isValid();
    },
    isSeasonValid() {
      if (!this.seasonEdit.startedAt || this.seasonEdit.startedAt.length !== 8) {
        return false;
      }
      if (!this.seasonEdit.endedAt || this.seasonEdit.endedAt.length !== 8) {
        return false;
      }
      return this.$moment(this.seasonEdit.startedAt, 'DD/MM/YY').isValid()
        && this.$moment(this.seasonEdit.endedAt, 'DD/MM/YY').isValid();
    },
    hasOverlappingError() {
      if (!this.season.error) {
        return false;
      }
      return 'ferry_seasons_overlap';
    },
    shouldDisable() {
      return this.ferrySeasonPrices.loading || this.season.loading;
    },
    enableCreateOrUpdateTrainWithTimesButton() {
      const zeroTime = '00:00';

      return this.currentDeparture.ferrySeasonId
        && (
          (
            this.currentDeparture.outBoundTimeFrom !== zeroTime
            && this.currentDeparture.outBoundTimeTo !== zeroTime
          )
          || (
            this.currentDeparture.inBoundTimeFrom !== zeroTime
            && this.currentDeparture.inBoundTimeTo !== zeroTime
          )
        );
    },
  },
  methods: {
    ...mapActions({
      routesLoad: 'transportation/routesLoad',
      setSupplier: 'transportation/suppliersSet',
      setPricesRoute: 'transportation/setPricesRoute',
      addSeason: 'transportation/addSeason',
      updateSeason: 'transportation/updateSeason',
      setSeason: 'transportation/setSeason',
      setSeasonDeparture: 'transportation/setSeasonDeparture',
      addSeasonDeparture: 'transportation/addSeasonDeparture',
      setSeasonDepartureDirection: 'transportation/setSeasonDepartureDirection',
      updateSeasonDeparture: 'transportation/updateSeasonDeparture',
      deleteSeasonDeparture: 'transportation/deleteSeasonDeparture',
      setFerryRoute: 'transportation/setFerryRoute',
      setFerrySeason: 'transportation/setFerrySeason',
      unsetSeason: 'transportation/unsetSeason',
      saveFerrySeasonPrices: 'transportation/saveFerrySeasonPrices',
      addFerrySeason: 'transportation/addFerrySeason',
      updateFerrySeason: 'transportation/updateFerrySeason',
      setCabinRoute: 'transportation/setCabinRoute',
      setExtraRoute: 'transportation/setExtraRoute',
      getDepartureDays: 'transportation/getDepartureDays',
      addDepartureDay: 'transportation/addDepartureDay',
      deleteDepartureDay: 'transportation/deleteDepartureDay',
      getDepartureBlockDays: 'transportation/getDepartureBlockDaysDates',
      addDepartureBlockDay: 'transportation/addDepartureBlockDay',
      deleteDepartureBlockDay: 'transportation/deleteDepartureBlockDay',
      getDepartureCabins: 'transportation/getDepartureCabins',
      getDepartureExtras: 'transportation/getDepartureExtras',
      loadDomains: 'transportation/domainsLoad'
    }),
    getNameSuffix(label, price) {
      switch (label) {
        case 'Persons':
          return `(${price.fromAge} - ${price.toAge})`;
        case 'Extras':
          return this.getExtraSuffix(price);
        default:
          return '';
      }
    },
    getExtraSuffix(price) {
      if (!price.timeFrom && !price.timeTo) {
        return '';
      }
      const from = price.timeFrom ? price.timeFrom.substring(0, 5) : '*';
      const to = price.timeTo ? price.timeTo.substring(0, 5) : '*';
      return `(${from} - ${to})`;
    },
    formatDate(date, format, placeholder) {
      const momentDate = this.$moment.utc(date);
      return momentDate.isValid() ?
        momentDate.local().format(format || 'DD-MM-YYYY HH:mm:ss') :
        (placeholder || '-');
    },
    saveFSPrices() {
      this.saveFerrySeasonPrices(
        this.ferrySeasonPrices.item,
      );
    },
    selectSeason(season) {
      this.isSeasonEditable = true;
      if (this.selectedRouteType === this.ferry) {
        this.seasonEdit.startDate = this.$moment(season.startDate).format('DD/MM/YY');
        this.seasonEdit.endDate = this.$moment(season.endDate).format('DD/MM/YY');
        this.setFerrySeason(season.id);
      } else {
        this.seasonEdit.name = season.name;
        this.seasonEdit.startedAt = this.$moment(season.startedAt).format('DD/MM/YY');
        this.seasonEdit.endedAt = this.$moment(season.endedAt).format('DD/MM/YY');
        this.seasonEdit.active = season.active;
        this.setSeason(season.id);
      }
    },
    getFerrySeasonEditFormatted() {
      return {
        startDate: this.$moment(this.seasonEdit.startDate, 'DD/MM/YY').format('YYYY-MM-DD'),
        endDate: this.$moment(this.seasonEdit.endDate, 'DD/MM/YY').format('YYYY-MM-DD'),
      };
    },
    newSeason() {
      this.isSeasonEditable = true;
      this.seasonEdit.startDate = null;
      this.seasonEdit.endDate = null;
      this.seasonEdit.ferryRouteId = this.route;
      this.seasonEdit.name = null;
      this.seasonEdit.startedAt = null;
      this.seasonEdit.endedAt = null;
      this.seasonEdit.active = true;
      this.unsetSeason();
    },
    getSeasonEditFormatted() {
      return {
        ferryRouteId: this.route,
        name: this.seasonEdit.name,
        startedAt: this.$moment(this.seasonEdit.startedAt, 'DD/MM/YY').format('YYYY-MM-DD'),
        endedAt: this.$moment(this.seasonEdit.endedAt, 'DD/MM/YY').format('YYYY-MM-DD'),
        active: this.seasonEdit.active,
      };
    },
    changeSupplier(supplier) {
      this.setSupplier(supplier);
      this.clearSeasonEdit();
      this.refreshRoutes();
    },
    clearSeasonEdit() {
      this.seasonEdit = {
        startDate: null,
        endDate: null,
        ferryRouteId: null,
        name: '',
        startedAt: null,
        endedAt: null,
        active: true,
      };
    },
    changeRoute(route) {
      this.selectedRouteType = route.type ? route.type : null;
      this.clearSeasonEdit();
      if (route.type && route.type === this.ferry) {
        this.setFerryRoute(route.id);
      } else {
        this.seasonEdit.ferryRouteId = route.id;
        this.setPricesRoute(route.id);
      }
    },
    refreshSuppliers() {
      if (this.suppliersError) {
        this.loadSuppliers();
      }
    },
    refreshRoutes() {
      this.routesLoad().then(() => {
        if (this.getRoutes.length) {
          this.changeRoute(this.getRoutes[0]);
        }
      });
    },
    resetCurrentDeparture() {
      this.currentDeparture = {
        ferryId: null,
        ferrySeasonId: null,
        name: '',
        outBoundTimeFrom: '',
        outBoundTimeTo: '',
        inBoundTimeFrom: '',
        inBoundTimeTo: '',
      };
    },
    newDepartureOrUpdate() {
      if (this.isSeasonDepartureEditable) {
        this.resetCurrentDeparture();
      }
      this.isSeasonDepartureEditable = !this.isSeasonDepartureEditable;
      this.currentDeparture.ferrySeasonId = this.season.selected;
    },
    editDepartureTime(departure) {
      this.currentDeparture.id = departure.id;
      this.currentDeparture.ferrySeasonId = departure.ferrySeasonId;
      this.currentDeparture.name = departure.name;
      const filters = this.$options.filters;
      this.currentDeparture.outBoundTimeFrom = filters.formatTime(departure.outBoundTimeFrom);
      this.currentDeparture.outBoundTimeTo = filters.formatTime(departure.outBoundTimeTo);
      this.currentDeparture.inBoundTimeFrom = filters.formatTime(departure.inBoundTimeFrom);
      this.currentDeparture.inBoundTimeTo = filters.formatTime(departure.inBoundTimeTo);
      this.isSeasonDepartureEditable = true;
    },
    async createOrUpdateDeparture() {
      let savedCorrectly = false;
      if (this.currentDeparture.id) {
        savedCorrectly = await this.updateSeasonDeparture(this.currentDeparture);
      } else {
        savedCorrectly = await this.addSeasonDeparture(this.currentDeparture);
      }
      if (savedCorrectly) {
        this.isSeasonDepartureEditable = false;
      }
    },
    editCabinPrice(seasonDeparture) {
      this.setSeasonDeparture(seasonDeparture);
      this.getDepartureCabins();
      this.departurePriceCabinEditable = !this.departurePriceCabinEditable;
    },
    editExtraPrice(seasonDeparture) {
      this.setSeasonDeparture(seasonDeparture);
      this.getDepartureExtras();
      this.departurePriceExtraEditable = !this.departurePriceExtraEditable;
    },
    editPriceDays(seasonDeparture, direction) {
      this.setSeasonDeparture(seasonDeparture);
      this.selectedDeparture = { ...seasonDeparture, direction };
      this.getDepartureDays({ seasonDepartureId: seasonDeparture.id, direction });
      this.departureDaysEditable = !this.departureDaysEditable;
    },
    editBlockDays(seasonDeparture, direction) {
      this.setSeasonDeparture(seasonDeparture);
      this.setSeasonDepartureDirection(direction);
      this.getDepartureBlockDays({ seasonDepartureId: seasonDeparture.id, direction });
      this.departureBlockDaysEditable = !this.departureBlockDaysEditable;
    },
    openConfirmDialog(type) {
      const vueComponent = this.$refs[type];
      if (vueComponent instanceof Array) {
        vueComponent[0].open();
      } else {
        vueComponent.open();
      }
    },
    closeEditConfirm(force = false) {
      if (this.dialogChangesMade && !force) {
        this.$refs.confirm.open();
      } else {
        this.confirmCloseEditDialog();
      }
    },
    confirmCloseEditDialog() {
      if (this.departureDaysEditable) {
        this.departureDaysEditable = false;
      } else if (this.departurePriceCabinEditable) {
        this.departurePriceCabinEditable = false;
      } else if (this.departureBlockDaysEditable) {
        this.departureBlockDaysEditable = false;
      } else if (this.departurePriceExtraEditable) {
        this.departurePriceExtraEditable = false;
      }
      this.pickerDays = [];
      this.setSeason(this.season.selected);
    },
    selectDepartureDay(e) {
      let action;
      let day;

      if (e.length >= this.departureDays.length) {
        action = 'add';
      } else {
        action = 'remove';
      }
      if (action === 'remove' && !e.length) {
        day = this.departureDays[0];
      } else if (action === 'add') {
        day = e.filter(t => this.departureDaysFiltered.indexOf(t) === -1)[0];
      } else {
        day = this.departureDays.filter(spc => e.indexOf(spc.availableAt) === -1)[0];
      }

      if (action === 'remove') {
        this.deleteDepartureDay({
          seasonDepartureId: this.selectedDeparture.id,
          direction: this.selectedDeparture.direction,
          body: {
            id: day.id,
          },
        });
      } else {
        this.addDepartureDay({
          seasonDepartureId: this.selectedDeparture.id,
          direction: this.selectedDeparture.direction,
          body: {
            availableAt: day,
          },
        });
      }
    },
  },
  created() {
    this.loadDomains();
    this.refreshRoutes();
  },
  filters: {
    formatTime(time) {
      if (!time) {
        return null;
      }
      const [h, m] = time.split(':');
      return `${h}:${m}`;
    },
  },
  watch: {
    departureDaysFiltered() {
      this.pickerDays = this.departureDaysFiltered;
    },
  },
};
</script>

<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs4>
        <v-layout>
          <v-flex xs11>
            <v-select
              :value="supplier"
              :items="suppliers"
              :loading="suppliersLoading"
              :label="$t('transportation.suppliers.title')"
              :disabled="suppliersLoading"
              :error-messages="suppliersError ? $t('transportation.suppliers.error') : undefined"
              :error="!!suppliersError"
              :append-icon="!suppliersError ? 'arrow_drop_down' : 'refresh'"
              item-value="id"
              dense
              @input="changeSupplier"
              @click:append="refreshSuppliers"
            >
              <template slot="item" slot-scope="props">
                <v-list-tile
                  two-lines
                  @click="props.tile.on.click">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ props.item.internalIdentifier }}
                      <span
                        v-if="!props.item.active"
                        class="pl-1 font-italic grey--text text--darken-1">
                        ({{ $t('inputs.misc.inactive') }})
                      </span>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              <template slot="selection" slot-scope="props">
                {{ props.item.internalIdentifier }}
                <span
                  v-if="!props.item.active"
                  class="pl-1 font-italic grey--text text--lighten-1">
                  ({{ $t('inputs.misc.inactive') }})
                </span>
              </template>
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs11>
            <v-autocomplete
              :items="getRoutes"
              :loading="suppliersLoading || routesLoading"
              :disabled="suppliersLoading || routesLoading"
              :value="route"
              :append-icon="!suppliersError ? 'arrow_drop_down' : 'refresh'"
              label="Routes"
              item-text="name"
              item-value="id"
              return-object
              @change="changeRoute"
            >
              <v-list-tile
                slot="prepend-item"
                class="grey--text">
                {{ getRoutes.length }} routes found
              </v-list-tile>
              <template slot="selection" slot-scope="{ item, selected }">
                <v-icon v-if="item.type === ferry" title="ferry">directions_boat</v-icon>
                <v-icon v-else-if="item.type === train" title="train">train</v-icon>
                <v-icon v-else title="flight">flight</v-icon>
                {{ item.name }}
              </template>
              <template slot="item" slot-scope="{ item, tile }">
                <v-list-tile-content>
                  <p>
                    <v-icon v-if="item.type === ferry" title="ferry">directions_boat</v-icon>
                    <v-icon v-else-if="item.type === train" title="train">train</v-icon>
                    <v-icon v-else title="flight">flight</v-icon>
                    {{ item.name }}
                  </p>
                </v-list-tile-content>
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex v-if="supplier && route" xs11>
            <v-layout align-center>
              <v-flex xs8>
                <h3>
                  Seasons
                  <v-btn :disabled="shouldDisable" icon @click="refreshRoutes">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </h3>
              </v-flex>
              <v-flex xs4 text-xs-right>
                <v-btn @click="newSeason" :disabled="shouldDisable" icon>
                  <v-icon>add</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-progress-linear v-if="season.loading" indeterminate />
            <v-list>
              <v-list-tile
                v-for="item in getSeasons"
                :disabled="shouldDisable"
                :key="item.id"
                :class="{'grey lighten-3': item.id === season.selected}"
                @click="selectSeason(item)"
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    <template v-if="selectedRouteType === ferry">
                      {{ formatDate(item.startDate, 'DD/MM/YY') }}
                      - {{ formatDate(item.endDate, 'DD/MM/YY') }}
                    </template>
                    <template v-else>
                  <span :class="{ 'red--text': !item.active }" :title="item.name">
                    {{ formatDate(item.startedAt, 'DD/MM/YY') }}
                    - {{ formatDate(item.endedAt, 'DD/MM/YY') }}
                  </span>
                    </template>
                  </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn
                    :disabled="shouldDisable"
                    :loading="item.id === season.selected && (ferrySeasonPricesLoading || departuresLoading)"
                    icon
                    ripple
                  >
                    <v-icon color="grey lighten-1">keyboard_arrow_right</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs11>
        <v-layout>
          <v-flex xs12>
            <template v-if="isSeasonEditable">
              <h2>
                Season period
              </h2>
              <v-divider class="pb-3" />
              <v-layout v-if="selectedRouteType === ferry" mb-5 wrap>
                <v-flex xs3>
                  <v-text-field
                    v-model="seasonEdit.startDate"
                    :disabled="shouldDisable"
                    label="Season start"
                    mask="##/##/##"
                    placeholder="dd/mm/yy"
                    hint="dd/mm/yy"
                    return-masked-value
                  />
                </v-flex>
                <v-flex xs3 offset-xs1>
                  <v-text-field
                    v-model="seasonEdit.endDate"
                    :disabled="shouldDisable"
                    label="Season end"
                    mask="##/##/##"
                    placeholder="dd/mm/yy"
                    hint="dd/mm/yy"
                    return-masked-value
                  />
                </v-flex>
                <v-flex xs3 offset-xs1>
                  <v-btn
                    v-if="season.selected"
                    :disabled="!isFerrySeasonValid || shouldDisable"
                    :loading="season.loading"
                    color="primary"
                    @click="updateFerrySeason(getFerrySeasonEditFormatted())"
                  >
                    Update
                  </v-btn>
                  <v-btn
                    v-else
                    :disabled="!isFerrySeasonValid || shouldDisable"
                    :loading="season.loading"
                    color="primary"
                    @click="addFerrySeason(getFerrySeasonEditFormatted())"
                  >
                    Create
                  </v-btn>
                </v-flex>
                <v-flex xs7>
                  <v-alert :value="hasOverlappingError">
                    The season dates are overlapping - please adjust
                  </v-alert>
                </v-flex>
              </v-layout>
              <v-layout v-else mb-5 wrap>
                <v-flex xs10>
                  <v-text-field
                    v-model="seasonEdit.name"
                    :disabled="shouldDisable"
                    label="Name"
                  />
                </v-flex>
                <v-flex xs2></v-flex>
                <v-flex xs2>
                  <v-text-field
                    v-model="seasonEdit.startedAt"
                    :disabled="shouldDisable"
                    label="Season start"
                    mask="##/##/##"
                    placeholder="dd/mm/yy"
                    hint="dd/mm/yy"
                    return-masked-value
                  />
                </v-flex>
                <v-flex xs2 offset-xs1>
                  <v-text-field
                    v-model="seasonEdit.endedAt"
                    :disabled="shouldDisable"
                    label="Season end"
                    mask="##/##/##"
                    placeholder="dd/mm/yy"
                    hint="dd/mm/yy"
                    return-masked-value
                  />
                </v-flex>
                <v-flex xs2 md2 offset-xs1>
                  <v-switch
                    v-model="seasonEdit.active"
                    :input-value="seasonEdit.active"
                    label="Active"
                  />
                </v-flex>
                <v-flex xs1 offset-xs1>
                  <v-btn
                    v-if="season.selected"
                    :disabled="!isSeasonValid || shouldDisable"
                    :loading="season.loading"
                    color="primary"
                    @click="updateSeason(getSeasonEditFormatted())"
                  >
                    Update
                  </v-btn>
                  <v-btn
                    v-else
                    :disabled="!isSeasonValid || shouldDisable"
                    :loading="season.loading"
                    color="primary"
                    @click="addSeason(getSeasonEditFormatted())"
                  >
                    Create
                  </v-btn>
                </v-flex>
                <v-flex xs7>
                  <v-alert :value="hasOverlappingError">
                    The season dates are overlapping - please adjust
                  </v-alert>
                </v-flex>
              </v-layout>
            </template>
            <template v-if="isSeasonEditable && !ferrySeasonPricesLoading && !departuresLoading && season.selected">
              <template v-if="ferrySeasonPrices.item && selectedRouteType === ferry">
                <h2>Season prices</h2>
                <v-divider class="pb-3" />
                <div
                  v-for="category in getSeasonPriceCategories"
                  v-if="ferrySeasonPrices.item[category.categoryProperty].length > 0"
                  :key="`category-${category.categoryProperty}`"
                  class="mb-5"
                >
                  <v-layout>
                    <v-flex xs3><b>{{ category.label }}</b></v-flex>
                    <v-flex class="text-xs-center" xs4>
                      FIT
                      <v-layout>
                        <v-flex class="text-xs-center" xs6>
                          Mon-Fri
                          <v-layout>
                            <v-flex xs6><small>Net</small></v-flex>
                            <v-flex xs6><small>Gross</small></v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex class="text-xs-center" xs6>
                          Sat-Sun
                          <v-layout>
                            <v-flex xs6><small>Net</small></v-flex>
                            <v-flex xs6><small>Gross</small></v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex class="text-xs-center" xs4 offset-xs1>
                      Special
                      <v-layout>
                        <v-flex class="text-xs-center" xs6>
                          Mon-Fri
                          <v-layout>
                            <v-flex xs6><small>Net</small></v-flex>
                            <v-flex xs6><small>Gross</small></v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex class="text-xs-center" xs6>
                          Sat-Sun
                          <v-layout>
                            <v-flex xs6><small>Net</small></v-flex>
                            <v-flex xs6><small>Gross</small></v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider />
                  <v-layout
                    v-for="price in ferrySeasonPrices.item[category.categoryProperty]"
                    :key="price[category.typeProperty].id"
                    align-center
                  >
                    <v-flex xs3>
                      {{ price[category.typeProperty].name }}
                      <span class="font-italic caption">
                        {{ getNameSuffix(category.label, price[category.typeProperty]) }}
                      </span>
                    </v-flex>
                    <v-flex xs4>
                      <v-layout>
                        <v-flex xs3 px-2>
                          <v-text-field
                            v-model="price.netPrice"
                            :disabled="shouldDisable"
                            class="pt-0"
                            single-line
                            hide-details
                            reverse
                          />
                        </v-flex>
                        <v-flex xs3 px-2>
                          <v-text-field
                            v-model="price.grossPrice"
                            :disabled="shouldDisable"
                            class="pt-0"
                            single-line
                            hide-details
                            reverse
                          />
                        </v-flex>
                        <v-flex xs3 px-2>
                          <v-text-field
                            v-model="price.netPriceWeekend"
                            :disabled="shouldDisable"
                            class="pt-0"
                            single-line
                            hide-details
                            reverse
                          />
                        </v-flex>
                        <v-flex xs3 px-2>
                          <v-text-field
                            v-model="price.grossPriceWeekend"
                            :disabled="shouldDisable"
                            class="pt-0"
                            single-line
                            hide-details
                            reverse
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4 offset-xs1>
                      <v-layout>
                        <v-flex xs3 px-2>
                          <v-text-field
                            v-model="price.netPriceSpecial"
                            :disabled="shouldDisable"
                            class="pt-0"
                            single-line
                            hide-details
                            reverse
                          />
                        </v-flex>
                        <v-flex xs3 px-2>
                          <v-text-field
                            v-model="price.grossPriceSpecial"
                            :disabled="shouldDisable"
                            class="pt-0"
                            single-line
                            hide-details
                            reverse
                          />
                        </v-flex>
                        <v-flex xs3 px-2>
                          <v-text-field
                            v-model="price.netPriceSpecialWeekend"
                            :disabled="shouldDisable"
                            class="pt-0"
                            single-line
                            hide-details
                            reverse
                          />
                        </v-flex>
                        <v-flex xs3 px-2>
                          <v-text-field
                            v-model="price.grossPriceSpecialWeekend"
                            :disabled="shouldDisable"
                            class="pt-0"
                            single-line
                            hide-details
                            reverse
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </div>
                <v-layout>
                  <v-flex xs-12 text-xs-right>
                    <v-btn
                      :disabled="shouldDisable"
                      :loading="ferrySeasonPrices.loading"
                      color="primary"
                      @click="saveFSPrices"
                    >
                      Save Prices
                    </v-btn>
                  </v-flex>
                </v-layout>
              </template>
              <template v-else>
                <h2>
                  Train times with prices
                  <v-btn
                    :color="isSeasonDepartureEditable ? 'warning' : 'primary'"
                    small
                    @click="newDepartureOrUpdate"
                  >
                    {{ isSeasonDepartureEditable ? 'Cancel' : 'Add new' }}
                  </v-btn>
                </h2>
                <v-divider class="pb-2" />
                <template v-if="isSeasonDepartureEditable">
                  <v-layout>
                    <v-flex xs4>
                      <v-text-field
                        v-model="currentDeparture.name"
                        placeholder="Name (optional)"
                      />
                    </v-flex>
                  </v-layout>
                  <h3>Times</h3>
                  <v-layout>
                    <v-flex class="py-0 mb-0" xs2>Outbound</v-flex>
                    <v-flex class="py-0 mb-0" xs3>
                      <v-text-field
                        v-if="currentDeparture"
                        v-model="currentDeparture.outBoundTimeFrom"
                        label="Time from"
                        placeholder="00:00"
                        prepend-icon="access_time"
                        mask="##:##"
                        class="py-0 my-0"
                        return-masked-value
                      >
                        <template v-if="currentDeparture" v-slot:append-outer>
                          <v-icon
                            v-if="currentDeparture.outBoundTimeFrom
                              && currentDeparture.outBoundTimeFrom !== '00:00'"
                            color="green"
                          >
                            check_circle
                          </v-icon>
                          <v-icon v-else color="red">warning</v-icon>
                        </template>
                      </v-text-field>
                    </v-flex>
                    <v-flex class="py-0 mb-0" xs3 offset-xs1>
                      <v-text-field
                        v-if="currentDeparture"
                        v-model="currentDeparture.outBoundTimeTo"
                        label="Time to"
                        placeholder="00:00"
                        prepend-icon="access_time"
                        mask="##:##"
                        class="py-0 my-0"
                        return-masked-value
                      >
                        <template v-if="currentDeparture" v-slot:append-outer>
                          <v-icon
                            v-if="currentDeparture.outBoundTimeTo
                              && currentDeparture.outBoundTimeTo !== '00:00'"
                            color="green"
                          >
                            check_circle
                          </v-icon>
                          <v-icon v-else color="red">warning</v-icon>
                        </template>
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex class="py-0 mb-0" xs2>Inbound</v-flex>
                    <v-flex class="py-0 mb-0" xs3>
                      <v-text-field
                        v-if="currentDeparture"
                        v-model="currentDeparture.inBoundTimeFrom"
                        label="Time from"
                        placeholder="00:00"
                        prepend-icon="access_time"
                        mask="##:##"
                        class="py-0 my-0"
                        return-masked-value
                      >
                        <template v-if="currentDeparture" v-slot:append-outer>
                          <v-icon
                            v-if="currentDeparture.inBoundTimeFrom
                              && currentDeparture.inBoundTimeFrom !== '00:00'"
                            color="green"
                          >
                            check_circle
                          </v-icon>
                          <v-icon v-else color="red">warning</v-icon>
                        </template>
                      </v-text-field>
                    </v-flex>
                    <v-flex class="py-0 mb-0" xs3 offset-xs1>
                      <v-text-field
                        v-if="currentDeparture"
                        v-model="currentDeparture.inBoundTimeTo"
                        label="Time to"
                        placeholder="00:00"
                        prepend-icon="access_time"
                        mask="##:##"
                        class="py-0 my-0"
                        return-masked-value
                      >
                        <template v-if="currentDeparture" v-slot:append-outer>
                          <v-icon
                            v-if="currentDeparture.inBoundTimeTo
                              && currentDeparture.inBoundTimeTo !== '00:00'
                            "
                            color="green"
                          >
                            check_circle
                          </v-icon>
                          <v-icon v-else color="red">warning</v-icon>
                        </template>
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex sm3 xs3 offset-xs6>
                      <v-btn
                        :disabled="!enableCreateOrUpdateTrainWithTimesButton"
                        :loading="departuresLoading"
                        :color="currentDeparture.id ? 'warning' : 'primary'"
                        @click="createOrUpdateDeparture"
                      >
                        {{ currentDeparture.id ? 'Update' : 'Create train with times' }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-divider class="pb-3" />
                </template>
                <v-layout v-if="departures.length" row>
                  <v-flex>
                    <v-data-table
                      :items="getSeasonDepartures"
                      :headers="selectedRouteType === 'train' ? headersTrain : headers"
                      :loading="departuresLoading"
                      class="print"
                      hide-actions
                    >
                      <template slot="items" slot-scope="props">
                        <tr :class="{ 'blue lighten-5': false }">
                          <td class="px-4">
                            {{ props.item.ferry ? props.item.ferry.name : '' }}
                            <template v-if="props.item.name">
                              <br>[{{ props.item.name }}]
                            </template>
                          </td>
                          <td class="px-2">
                            {{ props.item.outBoundTimeFrom | formatTime }}
                          </td>
                          <td class="px-2">
                            {{ props.item.inBoundTimeFrom | formatTime }}
                          </td>
                          <td class="px-2">
                            {{ props.item.outBoundTimeTo | formatTime }}
                          </td>
                          <td class="px-2">
                            {{ props.item.inBoundTimeTo | formatTime }}
                          </td>
                          <td class="px-2">
                            <v-btn fab
                                   dark
                                   small
                                   color="teal darken-2"
                                   style="height: 25px; width: 25px;"
                                   @click="editPriceDays(props.item, 'outbound')"
                            >
                              {{ props.item.counts.outboundDayCount }}
                            </v-btn>
                          </td>
                          <td class="px-2">
                            <v-btn fab
                                   dark
                                   small
                                   color="teal darken-2"
                                   style="height: 25px; width: 25px;"
                                   @click="editPriceDays(props.item, 'inbound')"
                            >
                              {{ props.item.counts.inboundDayCount }}
                            </v-btn>
                          </td>
                          <td class="px-2">
                            <v-btn fab
                                   dark
                                   small
                                   color="teal darken-2"
                                   style="height: 25px; width: 25px;"
                                   @click="editCabinPrice(props.item)"
                            >
                              {{ props.item.counts.cabinPriceCount }}
                            </v-btn>
                          </td>
                          <td class="px-2">
                            <v-btn fab
                                   dark
                                   small
                                   color="teal darken-2"
                                   style="height: 25px; width: 25px;"
                                   @click="editExtraPrice(props.item)"
                            >
                              {{ props.item.counts.extraPriceCount }}
                            </v-btn>
                          </td>
                          <td v-if="selectedRouteType === 'train'" class="px-2">
                            <v-btn fab
                                   dark
                                   small
                                   color="teal darken-2"
                                   style="height: 25px; width: 25px;"
                                   @click="editBlockDays(props.item, 'outbound')"
                            >
                              {{ props.item.counts.outboundBlockedDayCount }}
                            </v-btn>
                          </td>
                          <td v-if="selectedRouteType === 'train'" class="px-2">
                            <v-btn fab
                                   dark
                                   small
                                   color="teal darken-2"
                                   style="height: 25px; width: 25px;"
                                   @click="editBlockDays(props.item, 'inbound')"
                            >
                              {{ props.item.counts.inboundBlockedDayCount }}
                            </v-btn>
                          </td>
                          <td class="px-1 pr-1">
                            <v-icon
                              class="ferry-edit"
                              color="blue darken-2"
                              title="Edit name & times"
                              @click="editDepartureTime(props.item)"
                            >
                              edit
                            </v-icon>
                            <template v-if="props.item.id">
                              <v-icon
                                v-if="props.item.id"
                                :disabled="departuresLoading"
                                color="red darken-2"
                                title="Delete"
                                @click="openConfirmDialog(
                                  'confirm-delete-times-prices-dialog-' + props.item.id
                                )"
                              >
                                delete
                              </v-icon>
                              <confirm-dialog
                                title="Delete train times with prices"
                                description="Are you sure you want to delete the selected times ?"
                                :ref="'confirm-delete-times-prices-dialog-' + props.item.id"
                                @confirm="deleteSeasonDeparture(props.item.id)"
                              >
                              </confirm-dialog>
                            </template>
                          </td>
                        </tr>
                      </template>
                      <template slot="no-data">
                        <div v-if="departuresError || ferrySeasonPricesError">
                          <v-alert value="Something went wrong. Try again." icon="warning"/>
                        </div>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
                <v-dialog
                  v-model="departurePriceCabinEditable"
                  max-width="70%"
                  no-click-animation
                  persistent
                  @keydown.esc="confirmCloseEditDialog"
                >
                  <transportation-departure-price-cabin
                    :shown="departurePriceCabinEditable"
                    @close="confirmCloseEditDialog"
                  >
                  </transportation-departure-price-cabin>
                </v-dialog>
                <v-dialog
                  v-model="departurePriceExtraEditable"
                  v-click-outside="confirmCloseEditDialog"
                  max-width="70%"
                  no-click-animation
                  persistent
                  @keydown.esc="confirmCloseEditDialog"
                >
                  <transportation-departure-price-extra
                    :shown="departurePriceExtraEditable"
                    @close="confirmCloseEditDialog"
                  >
                  </transportation-departure-price-extra>
                </v-dialog>
                <v-dialog
                  v-model="departureDaysEditable"
                  width="unset"
                  no-click-animation
                  persistent
                >
                  <div style="display: flex; flex-direction: column">
                    <v-progress-circular
                      v-if="departureDaysLoading && !pickerDays.length"
                      color="#fff"
                      indeterminate
                    />
                    <v-date-picker
                      v-else
                      v-model="pickerDays"
                      :disabled="departureDaysLoading"
                      multiple
                      class="align-content-center"
                      @input="selectDepartureDay($event)"
                    />
                    <v-btn
                      v-if="!departureDaysLoading"
                      @click="confirmCloseEditDialog"
                    >
                      Close
                    </v-btn>
                  </div>
                </v-dialog>
                <v-dialog
                  v-model="departureBlockDaysEditable"
                  width="unset"
                  no-click-animation
                  persistent
                >
                  <transportation-departure-block-days
                  :shown="departureBlockDaysEditable"
                  @close="confirmCloseEditDialog"/>
                </v-dialog>
              </template>
            </template>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss">
.w-auto {
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/transportation/TransportationPrices.vue